<template>
  <div class="position-relative footer">
    <div class="bg-dark-gradient"></div>

    <div class="bg-dark d-flex flex-column">
      <b-container class="mt-3 mb-3">
        <b-row>
          <img class="d-block mr-sm-5" :alt="$t('site_title')" src="../assets/img/logo.svg"/>
          <b-col class="ml-5 d-flex flex-column">
            <b-link class="d-block mb-1 footer-link" :href="impressumzLink">{{ $t('imprint.title') }}</b-link>
            <b-link class="d-block mb-1 footer-link" :href="datenSchutzLink">{{ $t('privacy.title') }}</b-link>
            <div class="flex-grow-1"></div>
            <div class="mt-5">{{ $t('footer.copyright') }}</div>
          </b-col>
        </b-row>
      </b-container>
    </div>
    <div class="d-flex position-relative pl-5 pr-5">
      <b-row class="d-flex m-3 w-100 justify-content-center">
        <b-link class="d-block text-primary" href="https://www.deutscherimkerbund.de">{{ $t('footer.name') }}</b-link>
        <div class="ml-2 mr-2" v-if="!isMobile">&middot;</div>
        <div class="ml-2 mr-2" v-else>&nbsp;</div>
        <div>{{ $t('footer.street') }}</div>
        <div class="ml-2 mr-2" v-if="!isMobile">&middot;</div>
        <div class="ml-2 mr-2" v-else>&nbsp;</div>
        <div>{{ $t('footer.city') }}</div>
        <div class="ml-2 mr-2" v-if="!isMobile">&middot;</div>
        <div class="ml-2 mr-2" v-else>&nbsp;</div>
        <div>{{ $t('footer.tel') }}</div>
        <div class="ml-2 mr-2" v-if="!isMobile">&middot;</div>
        <div class="ml-2 mr-2" v-else>&nbsp;</div>
        <div>{{ $t('footer.fax') }}</div>
        <div class="ml-2 mr-2" v-if="!isMobile">&middot;</div>
        <div class="ml-2 mr-2" v-else>&nbsp;</div>
        <div>{{ $t('footer.email') }}</div>
      </b-row>
      <b-link class="d-block top-link icon-arrow_up text-decoration-none" :title="$t('footer.scroll_top')" @click="scrollUp"></b-link>
    </div>
  </div>
</template>

<script>
import config from '../config'
export default {
  name: 'FooterBar',
  data () {
    return {
      impressumzLink: config.serverUrl + '/impressum',
      datenSchutzLink: config.serverUrl + '/datenschutz'
    }
  },
  methods: {
    scrollUp () {
      document.body.scrollTop = 0
      document.documentElement.scrollTop = 0
    }
  },
  computed: {
    isMobile () {
      return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)
    }
  }
}
</script>

<style lang="scss" scoped>
  @import '../scss/config';

  .footer {
    font-family: "Roboto Condensed", sans-serif;

    .bg-dark-gradient {
      background: linear-gradient(rgba(0, 0, 0, 0), $black);
      //background: -moz-linear-gradient(top, rgba(0, 0, 0, 0) 0%, rgba(0, 0, 0, 0) 70%, rgba(0, 0, 0, 0.65) 100%);
      //background: -webkit-gradient(linear, left top, left bottom, color-stop(0%, rgba(0, 0, 0, 0)), color-stop(59%, rgba(0, 0, 0, 0)), color-stop(100%, rgba(0, 0, 0, 0.65)));
      //background: -webkit-linear-gradient(top, rgba(0, 0, 0, 0) 0%, rgba(0, 0, 0, 0) 59%, rgba(0, 0, 0, 0.65) 100%);
      //background: -o-linear-gradient(top, rgba(0, 0, 0, 0) 0%, rgba(0, 0, 0, 0) 59%, rgba(0, 0, 0, 0.65) 100%);
      //background: -ms-linear-gradient(top, rgba(0, 0, 0, 0) 0%, rgba(0, 0, 0, 0) 59%, rgba(0, 0, 0, 0.65) 100%);
      //background: linear-gradient(to bottom, rgba(0, 0, 0, 0) 0%, rgba(0, 0, 0, 0.2) 50%, rgba(0, 0, 0, 0.99) 100%);
      height: 1.5em;
      position: absolute;
      top: -1.5em;
      width: 100%;
      -webkit-appearance: none;
      -moz-appearance: none;
      appearance: none;
      border-radius: 0;
    }

    .footer-link {
      text-transform: uppercase;
    }

    .top-link {
      padding: 1.5rem 1rem;
      position: absolute;
      top: calc(-1.5rem - 0.5em);
      line-height: 1em;
      right: 0;
      background-color: $accent;
      color: $black !important;
    }

    img {
      width: 8rem;
      height: 4.5rem;
    }

    .bg-dark * {
      color: $white !important;
    }
  }
</style>
